//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'WorkStatistics',
  components: {
    assessStatistics: function assessStatistics() {
      return import('./components/assessStatistics');
    }
  },
  data: function data() {
    return {
      tabCur: 0,
      checkBtn: true
    };
  },
  mounted: function mounted() {},
  methods: {
    handleClick: function handleClick(number) {
      this.tabCur = number.index;
      this.$refs.assessStatistics.type = number.name;
      this.$refs.assessStatistics.getTableData();
    }
  }
};